
// /* JQuery */
var jquery = require("jquery");
window.$ = window.jQuery = jquery; // notice the definition of global variables here

import $ from 'jquery';
window.$ = window.jQuery = $;



/* BOOTSTRAP */
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css' // Import precompiled Bootstrap css
import '@fortawesome/fontawesome-free/css/all.css'



/* Hamburgers */
import 'hamburgers';
import 'hamburgers/dist/hamburgers.min.css';
/* OUR STYLE */
import '../styles/stylesheet.css';


/** END OF IMPORTS AND SHIT */




$(document).ready(function () {

    //mobile navigation hamburger
    var burger = $('.hamburger');
    burger.on('click', function () {
        burger.toggleClass("is-active");
    });
});

window.onload = function () {

    //home nav clicks
    var homepage = document.getElementById("homepage");

    homepage.addEventListener('click', () => scrollup());



    //add scrolling header effects
    addEventListener("scroll", function () { // or window.addEventListener("scroll"....
        var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
        if (st > lastScrollTop) {
            hide_header(); // downscroll code
        } else {
            show_header(); // upscroll code
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }, false);


};

/** HEADER STUFF **/

function scrollup() {
    window.scroll({
        top: 0,
        left: 240,
        behavior: 'smooth'
    });
}

function show_header() {
    var hd = document.getElementById('header_container');
    if (typeof hd != "undefined" && hd != null) {
        //hd.parentNode.parentNode.parentNode.parentNode.style.top = "0px";
        hd.parentNode.style.top = "0px";
        var burger = document.getElementsByClassName('hamburger')[0];

        if (burger.getAttribute("aria-expanded") == "true") {
            console.log("ITS EXPANDED!");
            burger.click();
        }
    }
}

function hide_header() {
    var hd = document.getElementById('header_container');
    var burger = document.getElementsByClassName('hamburger')[0];
    //console.log(hd);
    if (typeof hd != "undefined" && hd != null) {

        hd.parentNode.style.top = "-100px";

        if (burger.getAttribute("aria-expanded") == "true") {
            console.log("ITS EXPANDED!");
            burger.click();
        }
    }
}
/** END HEADER STUFF **/